import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard  implements CanActivate {
    constructor(private jwtHelper: JwtHelperService, private router: Router) {}

    getRole(): string | null {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            const decodedToken = this.jwtHelper.decodeToken(token);
            return decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        }
        return null;
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredRoles: string[] = route.data['roles'] || [];
        const userRole = this.getRole(); // Obtener el rol del usuario

        if (requiredRoles.includes(userRole)) {
            return true;
        }

        this.router.navigate(['/unauthorized']);
        return false;
    }
}